function BottomBar() {
    return (
        <footer className="bg-gradient-to-r bg-[#0a1622] w-full text-white text-center text-xs py-1">
            <span className="opacity-100">© blockballot.com | The Future Of Voting</span>
        </footer>
    );
}

export default BottomBar;
